/* eslint-disable */
/**
 * @author Rahul Nainala
 * @description Cloning the 3D model for reuse and assiging some varaibles.
 */
import React, { useEffect, useMemo } from "react";

const ModelInstance = ({
    gltf,
    name,
    scale,
    position,
    onClick,
    isSelected,
    colorHelper,
    clickable
}) => {
    const clonedScene = useMemo(() => gltf.scene.clone(), [gltf.scene]);
    useEffect(() => {
        let meshIndex = 0;
        clonedScene.traverse((node) => {
            if (node.isMesh) {
               if(clickable === true){
                 node.material = node.material.clone();
                node.material.name = `${name}_${node.name}_material_${meshIndex}`;
                node.name = `${name}_${node.name}`;
                node.userData.id = `${node.name}`;
                node.userData.isClickable = true;
                meshIndex++;
               }else{
                 node.material = node.material.clone();
                node.material.name = `${name}_${node.name}_material_${meshIndex}`;
                node.name = `${name}_${node.name}`;
                node.userData.id = `${node.name}`;
                node.userData.isClickable = false;
                meshIndex++;
               }
            }
        });
    }, [clonedScene, name, clickable]);

    useEffect(() => {
        clonedScene.traverse((node) => {
            if (node.isMesh) {
                if (isSelected) {
                    if (!node.userData.originalColor) {
                        node.userData.originalColor = node.material.color.clone();
                    }
                    node.material.color.set(colorHelper || "#ff0000");
                } else {
                    if (node.userData.originalColor) {
                        node.material.color.set(node.userData.originalColor);
                    } else {
                        node.material.color.set("#ffffff");
                    }
                }
            }
        });
    }, [isSelected, clonedScene, colorHelper]);

    return (
        <primitive
            object={clonedScene}
            scale={scale}
            position={position}
            name={name}
            onClick={onClick}
        />
    );
};

export default ModelInstance;
